/**
 * A utility function to create a result object with a schema.
 * @param {Object} schemaDefinition - The schema definition for the result object.
 * @returns {Function} - A function to create a result object.
 */
export function useResult (schemaDefinition) {
  // .freeze() to prevent mutation
  const schema = Object.freeze(schemaDefinition)

  const schemaKeys = Object.freeze(_.keys(schema))

  function result (fields = {}) {
    // We want to pick the keys from the fields object that are in the schema keys
    // and then clone the fields object
    const newResult = _(fields).pick(schemaKeys).cloneDeep()

    // Clone the schema to prevent mutation
    const baseResult = _.cloneDeep(schema)

    // Merge the new result with the base result
    // The new result will override the base result if the key exists in the new result
    const result = _.defaultsDeep(newResult, baseResult)

    return Object.freeze(result)
  }

  return {
    result
  }
}
